import React, { useState, useEffect, useRef } from 'react';
import { useWindowSize } from 'hooks/use-window-size';
import { bpMedium } from 'constants/breakpoints';
import { THEME_DARK } from 'constants/color-theme';
import { LABEL_OPEN_GALLERY } from 'constants/labels';
import { SIZE_DEFAULT } from 'constants/sizes';
import { chunk } from 'modules/chunk-array';
import PropTypes from 'prop-types';
import { Lightbox } from 'components/media-gallery/lightbox';
import { Media } from 'components/media-gallery/media';
import { Grid } from 'components/media-gallery/grid';
import { Button } from 'components/buttons';
import { Arrow } from 'components/icons';
import Slider from 'react-slick';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';

export const MediaGallery = ({ theme, medias, featuredAsset }) => {
  const [lightboxOpen, toggleLightbox] = useState(false);
  const [mediaNumber, setMediaNumber] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [active, setActive] = useState(null);
  const imagesLength = medias.length;
  const gridSize = chunk(medias, 4);
  const { width } = useWindowSize();
  const isMobile = width <= bpMedium;
  const productPageV2 = useSelector(
    (state) => state.product.data.productPageV2
  );
  const sliderRef = useRef(null);
  const navSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    beforeChange: (current, next) => {
      setActiveSlide(next);
    },
    //nextArrow: <SampleNextArrow className={styles['next-arrow']} />,
    //prevArrow: <SamplePrevArrow className={styles['prev-arrow']}/>,
    //nextArrow: <SampleNextArrow className={styles['next-arrow']} />,
    //prevArrow: <SamplePrevArrow className={styles['prev-arrow']}/>,
  };
  useEffect(() => {
    if (!lightboxOpen) setActive(null);
    if (lightboxOpen) {
      document.body.classList.add('overflow-hidden');
    }
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [lightboxOpen, active, featuredAsset, medias]);

  let slides = medias.map((slide) => {
    if (productPageV2) {
      return (
        <div className={styles['slide']}>
          <img src={slide.url} alt={slide.title} />{' '}
        </div>
      );
    } else {
      return false;
    }
  });

  console.log(featuredAsset);

  if (slides) {
    slides.unshift(
      <div className={styles['slide']}>
        <Media url={featuredAsset.url} featuredAsset />
      </div>
    );
  }

  return (
    <div
      className={
        styles['gallery'] + ' ' + (productPageV2 ? styles['ppv2'] : '')
      }
    >
      {!productPageV2 && (
        <>
          <div className={styles['left-side']}>
            <Media url={featuredAsset.url} featuredAsset />
            <div className={styles[theme] + ' ' + styles['gradient']} />
          </div>
          <div className={styles['right-side']}>
            {!lightboxOpen && !isMobile && (
              <button onClick={() => toggleLightbox(!lightboxOpen)}>
                open gallery <Arrow />
              </button>
            )}
            {!lightboxOpen && isMobile && (
              <Button
                size={SIZE_DEFAULT}
                theme={THEME_DARK}
                handleClick={() => toggleLightbox(!lightboxOpen)}
                label={LABEL_OPEN_GALLERY}
              />
            )}
            <Grid
              grid={gridSize[0]}
              active={active}
              imagesLength={imagesLength}
              setActive={setActive}
              toggleLightbox={toggleLightbox}
              setMediaNumber={setMediaNumber}
            />
          </div>
        </>
      )}
      {productPageV2 && (
        <section>
          <div>
            <div className={styles['right-side']}>
              <button onClick={() => toggleLightbox(!lightboxOpen)}>
                open gallery <Arrow />
              </button>
            </div>
            <div className={'slider-container ' + styles['slider-container']}>
              <Slider ref={sliderRef} {...navSettings}>
                {slides}
              </Slider>
            </div>
            <div className={styles['slide-details']}>
              <div className={styles['slide-numbers']}>
                <p>
                  {activeSlide + 1}/{slides.length - 3}
                </p>
              </div>
              <div className={styles['slide-seperator']}>
                <hr />
              </div>
              <div className={styles['slide-arrows']}>
                <span onClick={() => sliderRef.current.slickPrev()}>
                  <svg
                    width="13"
                    height="19"
                    viewBox="0 0 13 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 1L1 9.5L12 18" stroke="black" />
                  </svg>
                </span>
                <span onClick={() => sliderRef.current.slickNext()}>
                  <svg
                    width="13"
                    height="19"
                    viewBox="0 0 13 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1 18L12 9.5L1 1" stroke="black" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </section>
      )}

      {lightboxOpen && (
        <Lightbox
          medias={[featuredAsset, ...medias]}
          lightboxOpen={lightboxOpen}
          imagesLength={imagesLength}
          mediaNumber={mediaNumber}
          featuredAsset={featuredAsset}
          active={active}
          setActive={setActive}
          setMediaNumber={setMediaNumber}
          toggleLightbox={toggleLightbox}
        />
      )}
    </div>
  );
};

MediaGallery.defaultProps = {
  theme: 'pink',
  featuredAsset: {
    url: 'https://via.placeholder.com/590x536',
    title: 'Featured asset',
    caption: '',
  },
};

MediaGallery.propTypes = {
  theme: PropTypes.string,
  medias: PropTypes.array.isRequired,
  featuredAsset: PropTypes.object.isRequired,
};
